import styled, { css } from '../styled-components';

interface Props {
    dark?: boolean;
    gray?: boolean;
    image?: string;
}

const backgroundImage = props =>
    props.image &&
    css`
        background-image: url(${(p: { image: string }) => p.image});
        background-size: 100%;
        background-position: center 40%;
    `;

const links = props =>
    props.dark &&
    css`
        a {
            color: white !important;
        }
    `;

export default styled<Props, any>('section')`
    background-color: red;
    padding: 2rem 0 6rem 0;
    color: ${props => (props.dark ? props.theme.textInverted : props.theme.text)};
    background-color: ${props =>
        props.dark ? props.theme.primary : props.gray ? props.theme.lightGray : props.theme.background};
    ${backgroundImage};
    ${links};
`;



// WEBPACK FOOTER //
// ./src/components/Section.tsx